import { Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { ConsentService } from '@markant-platform/consent/data-access';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';
import { InternalCmsLink } from '@markant-platform/shared/content/model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-inital-consent-dialog',
  templateUrl: './inital-consent-dialog.component.html',
  styleUrls: ['./inital-consent-dialog.component.scss'],
})
export class InitalConsentDialogComponent {
  @Input()
  open = false;

  @Input()
  termsOfUseLink$: Observable<InternalCmsLink> = of();

  @Input()
  privacyPolicyLink$: Observable<InternalCmsLink> = of();

  @Output()
  openChange = new EventEmitter<boolean>();

  @Output()
  approveChange = new EventEmitter<boolean>();

  constructor(
    private readonly consentService: ConsentService,
    private readonly snackBarService: SnackbarService,
    private readonly authenticatedService: AuthenticatedUserService,
    private readonly destroyRef: DestroyRef
  ) {}

  closeDialog(approved: boolean): void {
    forkJoin([this.authenticatedService.getPlatformUserId(), this.authenticatedService.getOrganizationId()])
      .pipe(
        switchMap(([userId, organizationId]) => this.consentService.approveConsent(userId, organizationId)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: () => {
          this.approveChange.emit(approved);
          this.open = false;
          this.openChange.emit(false);
        },
        error: () => {
          this.snackBarService.showErrorSnackbarWithTransloco('error.occurred');
        },
      });
  }
}
